import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { getCurrentDomain } from '../config/domains';
import { useAuth } from '../context/AuthContext';
import { AiHeader } from './ai/AiHeader';

const Header: React.FC = () => {
  const domain = getCurrentDomain();
  const { isAuthenticated, isAdmin, isUserAdmin, isBlogger, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Pitfall 1 fix: on .ai, short-circuit to the new dark AiHeader so the
  // inline `style={{ backgroundColor: domain.primaryColor }}` below never
  // paints navy over the Direction B dark theme. Non-.ai domains continue
  // through the legacy markup unchanged.
  if (domain.id === 'ai') {
    return <AiHeader />;
  }

  const handleLogout = () => {
    logout();
    navigate('/');
    setMobileMenuOpen(false);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="header" style={{ backgroundColor: domain.primaryColor }}>
      <div className="container">
        <div className="header-content">
          {/* Logo/Brand - clickable home link */}
          <Link to="/" className="brand-link" onClick={closeMobileMenu}>
            <div className="brand-content">
              {domain.logoPath && (
                <img
                  src={domain.logoPath}
                  alt={`${domain.name} logo`}
                  className="brand-logo"
                />
              )}
              {!domain.logoPath && (
                <div>
                  <h1 className="site-title">{domain.name}</h1>
                  <p className="site-tagline">{domain.tagline}</p>
                </div>
              )}
            </div>
          </Link>

          {/* Hamburger Menu Button - Mobile Only */}
          <button
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle navigation menu"
            aria-expanded={mobileMenuOpen}
          >
            <span className={`hamburger ${mobileMenuOpen ? 'active' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>

          {/* Navigation */}
          <nav className={`nav-container ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <ul className="nav">
              <li><NavLink to="/about" onClick={closeMobileMenu}>About</NavLink></li>
              {/* Hide Products & Services for intrnauts.dev */}
              {domain.id !== 'dev' && (
                <li>
                  <NavLink
                    to={domain.id === 'manzoorulhassan' ? '/career' : '/services'}
                    onClick={closeMobileMenu}
                  >
                    {domain.id === 'manzoorulhassan' ? 'Career & Skills' : 'Products & Services'}
                  </NavLink>
                </li>
              )}
              {domain.hasBlog && <li><NavLink to="/blog" onClick={closeMobileMenu}>Blog</NavLink></li>}
              <li><NavLink to="/contact" onClick={closeMobileMenu}>Contact</NavLink></li>
              {isAuthenticated ? (
                <>
                  <li><NavLink to="/profile" onClick={closeMobileMenu}>Profile</NavLink></li>
                  {/* Show Admin link for superusers and user_admins */}
                  {(isAdmin || isUserAdmin) && <li><NavLink to="/admin" onClick={closeMobileMenu}>Admin</NavLink></li>}
                  <li>
                    <button
                      onClick={handleLogout}
                      className="logout-btn"
                    >
                      Logout
                    </button>
                  </li>
                </>
              ) : (
                // Only show Account link on dev domain
                domain.id === 'dev' && (
                  <li><NavLink to="/login" onClick={closeMobileMenu}>Account</NavLink></li>
                )
              )}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
